/// <reference path="common.module.ts" />

module Meevo.Components.Common {

    export interface IProductInfo {
        sku?: string;
        displayName?: string;
        barCode?: string
        variantDisplayName?: string;
        productId?: Guid | string;
        productInventoryType?: Meevo.Model.ProductInventoryTypeEnum;
    }

    export class InventoryCommonContext {

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService) {

        }

        replacePipeSeperatorWithSpace = (variantName) => {
            return variantName ? variantName.replace(/[\|]/g, " ") : variantName;
        }

        getItemDisplayName(item: IProductInfo) {
            if (!item) {
                return "";
            }

            let variantDisplayName = item.variantDisplayName ? ` - ${this.replacePipeSeperatorWithSpace(item.variantDisplayName)}` : "";
            let barCode = item.barCode ? ` : ${item.barCode}` : ""
            return `${item.sku} : ${item.displayName}${variantDisplayName}${barCode}`;
        }

        showScrollbarSpacer(elemName) {
            var dd = $(elemName);
            return (dd.length > 0 && dd[0].scrollHeight > dd[0].clientHeight);
        }

        /**
         * Open selected Product in Product Screen
         * @param {PurchaseOrderDetails} item
         */
        openProductDefinition(item: IProductInfo): void {
            let productId: Guid | string = item.productId;
            if (!productId) return;

            // Build params for loading Product Definition
            let stateParams = {
                id: productId,
                actionState: Meevo.Model.MaintenanceFormState.Readonly,
                targetState: Meevo.Model.MaintenanceFormVisualState.Detail
            };

            if (item.productInventoryType == Meevo.Model.ProductInventoryTypeEnum.Other) {
                this.$rootScope.$broadcast("gotoState", {
                    stateName: this.appSettings.ROUTE_NAMES.miscSupplyDefinitions,
                    stateParams: stateParams
                });
            }
            else {
                this.$rootScope.$broadcast("gotoState", {
                    stateName: this.appSettings.ROUTE_NAMES.product,
                    stateParams: stateParams
                });
            }
        }

    }
}
